import React from 'react';
import { connect } from 'react-redux';
import ConfirmComponent from '../../confirm-component';
import { featureListing } from '../../actions';

// Create an editable cell renderer
const ListingFeaturedCell = ({
  cell: { value: initialValue },
  data: listing,
  dispatch
}) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  function setFeatureListing() {
    dispatch(featureListing(listing._id, !listing.isFeatured));
    setModalOpen(false);
  }

  let featuredMessage = listing.isFeatured ?
    'Are you sure you want to not feature this listing? This will remove it from the Featured Listing section of relevant Destination pages' :
    'Are you sure you want to feature this listing? This will add the listing to Featured Listing section of relevant Destination pages';

  return <div>
    <div className="toggle-active">
      <label htmlFor={`${listing._id}.featured`} className="switch" onClick={() => setModalOpen(true)} >
        <input name={`${listing._id}.featured`} readOnly={true} type="checkbox" checked={listing.isFeatured} />
        <span className="slider round"></span>
      </label>
    </div>
    {modalOpen &&
      (<ConfirmComponent text={featuredMessage} onSubmit={setFeatureListing} onClose={() => setModalOpen(false)} />)
    }
  </div>
}
export default connect()(ListingFeaturedCell);
